import { Masonry } from "@leagueplatform/masonry";
import { MASONRY } from "common/constants";

export const HighlightsStep = () => (
  <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_FEATURE_HIGHLIGHTS} />
);
